<template>
    <article v-if="item !== null" class="full-screen-video" :class="getModuleThemeClass()">
        <span v-if="item.Preline != ''" class="full-screen-video__preline">{{ item.Preline }}</span>
        <h2 v-if="item.Headline != ''" class="full-screen-video__headline">{{ item.Headline }}</h2>
        <span v-if="item.Postline != ''" class="full-screen-video__postline">{{ item.Postline }}</span>
        <div v-if="item.Video != ''" class="full-screen-video__video-wrap">
            <iframe class="video__iframe full-screen-video__iframe" :src="getVideoIframeUrl()" :title="item.Headline" allow="autoplay; fullscreen"></iframe>
        </div>
        <div v-else-if="item.SelfHostedVideo != ''" class="full-screen-video__video-wrap">
            <video class="full-screen-video__video" ccontrolslist="nofullscreen nodownload" disablepictureinpicture disableremoteplayback loop playsinline poster preload="metadata" tabindex="-1" muted autoplay>
                <source :src="item.SelfHostedVideo.Path" type="video/mp4">
            </video>
        </div>
    </article>
</template>
<script>
import { useItem } from '../composables/item';
import { useVideo } from '../composables/video';
const { getThemeClass } = useItem();
const { getVimeoId } = useVideo();

export default {
    name: 'FullScreenVideo',
    props: {
        item: {
            type: Object,
            default: null
        }
    },
    methods: {
        getVideoIframeUrl() {
            const videoId = getVimeoId(this.item.Video);
            return this.item.Video !== '' ? (
                this.item.ShowControls ?
                    `https://player.vimeo.com/video/${videoId}?title=0&byline=0&dnt=1` :
                    `https://player.vimeo.com/video/${videoId}?background=1&autoplay=1&loop=1&dnt=1`
            ) : null;
            // return this.item.Video !== '' ? `https://player.vimeo.com/video/${videoId}?background=1&autoplay=1&loop=1&dnt=1` : null;
        },
        getModuleThemeClass() {
            return getThemeClass(this.item);
        }
    }
};
</script>
